export const RATES_RESTRICTED_PERCENTAGES = [0, 50, 75, 100];